import { Link } from "react-router-dom";
import { useI18n } from "../context/I18nContext";
import { useCurrency } from "../context/CurrencyContext";
import { BedDouble, Bath, Maximize2, MapPin } from "lucide-react";

export default function PropertyCard({ property }) {
  const { t, lang } = useI18n();
  const { format } = useCurrency();
  const rawImg = property.images?.[0] || "https://images.pexels.com/photos/31817160/pexels-photo-31817160.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
  const img = rawImg.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${rawImg}` : rawImg;

  const suffix =
    property.category === "rental_long"
      ? t.property.perMonth
      : property.category === "rental_short"
      ? t.property.perNight
      : "";

  return (
    <Link
      to={`/property/${property.property_id}`}
      className="card-hover group block"
      data-testid={`property-card-${property.property_id}`}
    >
      <div className="squircle relative aspect-[4/3] bg-[#f5f5f7]">
        <img
          src={img}
          alt={property.title}
          className="w-full h-full object-cover transition-transform duration-700 ease-[cubic-bezier(0.25,1,0.5,1)] group-hover:scale-105"
          loading="lazy"
        />
        {property.featured && (
          <div className="absolute top-4 left-4 bg-white/90 backdrop-blur px-3 py-1 rounded-full text-[11px] font-medium tracking-wide text-[#1d1d1f]">
            {lang === "fr" ? "Sélection" : "Featured"}
          </div>
        )}
      </div>
      <div className="pt-5 px-1">
        <div className="flex items-center gap-1 text-[12px] text-[#86868b] mb-2">
          <MapPin size={12} strokeWidth={1.5} />
          <span>{property.location}, {property.city}</span>
        </div>
        <h3 className="text-[17px] font-medium text-[#1d1d1f] leading-snug tracking-tight mb-2 line-clamp-1">
          {property.title}
        </h3>
        <div className="flex items-baseline gap-1 mb-3">
          <span className="text-[20px] font-semibold text-[#1d1d1f] tracking-tight">
            {format(property.price)}
          </span>
          <span className="text-[13px] text-[#86868b]">{suffix}</span>
        </div>
        <div className="flex items-center gap-4 text-[12px] text-[#86868b]">
          {property.bedrooms > 0 && (
            <span className="flex items-center gap-1">
              <BedDouble size={13} strokeWidth={1.5} />
              {property.bedrooms} {t.property.bedrooms}
            </span>
          )}
          {property.bathrooms > 0 && (
            <span className="flex items-center gap-1">
              <Bath size={13} strokeWidth={1.5} />
              {property.bathrooms} {t.property.bathrooms}
            </span>
          )}
          {property.surface > 0 && (
            <span className="flex items-center gap-1">
              <Maximize2 size={13} strokeWidth={1.5} />
              {property.surface} {t.property.surface}
            </span>
          )}
        </div>
      </div>
    </Link>
  );
}
